<template>
    <form class="form-register" @submit.prevent="submit">

        <div class="form-group">
            <span class="error-input-container"
                  :class="{'has-error': ($v.auth.email.$error && formSubmitted)
                  && (!$v.auth.email.required || !$v.auth.email.email)}">
                <input type="text" class="form-control-v2" :placeholder="translate.login.emailOrPhoneLogin"
                       v-model.trim="$v.auth.email.$model" name="email" autocomplete="off">
            </span>

            <span v-if="$v.auth.email.$error || formSubmitted">
                <error-component v-if="!$v.auth.email.required" :message="translate.login.emailRequired"></error-component>
            </span>
        </div>

        <div class="form-group">
            <span class="error-input-container"
                  :class="{'has-error': ($v.auth.password.$error || formSubmitted)
                  && !$v.auth.password.required}">
                <input type="password" class="form-control-v2" :placeholder="translate.login.password"
                       v-model.trim="$v.auth.password.$model" name="password">
            </span>
            <span v-if="$v.auth.password.$error || formSubmitted">
                <error-component v-if="!$v.auth.password.required" :message="translate.login.passwordRequired"></error-component>
            </span>
        </div>

        <div class="d-flex flex-column gap-2">
            <button-with-loading-component class="w-100 btn btn-rebrand-primary-outline btn-rebrand-sm"
                                           :disabled="$v.$anyDirty && $v.$invalid"
                                           type="submit"
                                           :text="translate.login.login"
                                           :loading="loading"
            ></button-with-loading-component>
            <a :href="regionRelativeUrl('/users/forgot-password/')"
               class="w-100 btn btn-rebrand-grey-outline btn-rebrand-sm">{{ translate.login.forgotPassword }}</a>
        </div>

        <div v-if="formError" class="alert alert-danger alert-dismissible fade show" role="alert">
            {{ formError }}
        </div>

    </form>
</template>

<script>
import {validationMixin} from 'vuelidate'
import {required} from 'vuelidate/lib/validators';
import regionsUrlMixin from "@/components/mixins/regions/regionsUrlMixin";
import {regionRelativeUrl} from "@/core/utils/helpers/regions/regionUrlHelper";
import {setCookie} from "@/core/utils/helpers/cookieHelper";
import CookiesEnum from "@/core/constants/cookiesEnum";

const data = () => ({
    formError: '',
    formSubmitted: false,
    auth: {
        email: '',
        password: ''
    },
    loading: false,
});

async function authenticate() {
    const payload = {
        identifier: this.auth.email,
        password: this.auth.password,
    }

    const [err, response] = await to(
        api.auth.loginAsPunter(payload)
    );

    if (err) {
        const errors = _.get(err, 'response.data.errors', []);
        const hasWrongRole = errors.some(e => e.key === 'wrong role');

        if (hasWrongRole) {
            return window.location.href = regionRelativeUrl('/users/login/');
        }

        this.loading = false;
        this.formSubmitted = false;
        this.formError = errors.map(e => _.get(this.translate, e.key) || e.key).join(', ');

        return;
    }

    setCookie(CookiesEnum.JWT, _.get(response, 'data.results.token'));
    this.$emit('successRedirect');
}

function submit() {
    this.loading = true;
    this.formSubmitted = true;
    this.formError = false;

    if (this.$v.$invalid) {
        this.loading = false;
    } else {
        this.authenticate();
    }
}

export default {
    mixins: [validationMixin, regionsUrlMixin],
    data,
    validations: {
        auth: {
            email: {
                required
            },
            password: {
                required,
            },
        }
    },
    props: ['galleryId', 'isAll'],
    methods: {
        authenticate,
        submit
    },
    computed: {
        ...mapState([
            'translate'
        ]),
    },
};
</script>
